// Диалог "О программе"

import { Modal } from '../layout/Modal';
import { FileText, BookOpen, Code, User } from 'lucide-react';

interface AboutDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export function AboutDialog({ isOpen, onClose }: AboutDialogProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="О программе">
      <div className="modal-section">
        <h3 className="modal-section-title">
          <FileText size={18} style={{ marginRight: '8px', verticalAlign: 'middle' }} />
          Калькулятор выбора сечения кабеля
        </h3>
        <div className="modal-meta">
          <div className="modal-meta-item">
            <strong>Версия:</strong> 1.0.0
          </div>
        </div>
        <p className="modal-section-text">
          Веб-приложение для расчёта сечения кабеля по потере напряжения и длительно допустимому току.
          Позволяет быстро подобрать оптимальное сечение проводника с учётом различных условий прокладки.
        </p>
      </div>

      <div className="modal-section">
        <h3 className="modal-section-title">
          <Code size={18} style={{ marginRight: '8px', verticalAlign: 'middle' }} />
          Технологии
        </h3>
        <ul className="modal-list">
          <li>React 19</li>
          <li>TypeScript 5.9</li>
          <li>Vite 7</li>
        </ul>
      </div>

      <div className="modal-section">
        <h3 className="modal-section-title">
          <BookOpen size={18} style={{ marginRight: '8px', verticalAlign: 'middle' }} />
          Нормативные документы
        </h3>
        <ul className="modal-list">
          <li>
            <strong>ПУЭ изд. 7</strong> — Правила устройства электроустановок
          </li>
          <li>
            <strong>ГОСТ 22483-2012</strong> — Жилы токопроводящие для кабелей, проводов и шнуров
          </li>
          <li>
            <strong>ГОСТ 31996-2012</strong> — Кабели силовые с пластмассовой изоляцией
          </li>
        </ul>
      </div>

      <div className="modal-section">
        <h3 className="modal-section-title">
          <User size={18} style={{ marginRight: '8px', verticalAlign: 'middle' }} />
          Разработчик
        </h3>
        <p className="modal-section-text">
          <strong>Код Энергетики</strong>
        </p>
        <p className="modal-section-text">
          ВКонтакте: <a href="https://vk.com/kodenergetiki" target="_blank" rel="noopener noreferrer">https://vk.com/kodenergetiki</a>
        </p>
        <p className="modal-section-text">
          Сайт: <a href="https://www.kodenergetiki.ru" target="_blank" rel="noopener noreferrer">www.kodenergetiki.ru</a>
        </p>
      </div>
    </Modal>
  );
}
